import {
  ApiConfirmedAggregatedOrder,
  ApiMutualFundAsset,
  ApiOutstandingAggregatedOrder,
  ApiSegregatedPortfolioAsset
} from 'api/rtk-api'

export type OutstandingOrder = ApiOutstandingAggregatedOrder
export type ConfirmedOrder = ApiConfirmedAggregatedOrder
export type Order = ApiOutstandingAggregatedOrder | ApiConfirmedAggregatedOrder
export type OutstandingOrders = OutstandingOrder[]
export type ConfirmedOrders = ConfirmedOrder[]
export type Orders = OutstandingOrders | ConfirmedOrders

export enum OrderType {
  Outstanding = 'outstanding',
  Confirmed = 'confirmed'
}

export function isConfirmedOrder(order: Order, type: OrderType): order is ConfirmedOrder {
  return type === OrderType.Confirmed || !!(order as ConfirmedOrder).confirmationAuthor
}

export function isMutualFund(
  asset: ApiMutualFundAsset | ApiSegregatedPortfolioAsset
): asset is ApiMutualFundAsset {
  return (asset as ApiMutualFundAsset).type === 'MutualFund'
}

export function isBuyOrder(order: Order) {
  return order.direction === 'Subscription'
}
